<div class="flex flex-1 flex-row">
	<div class="w-1/2">
		<h2>Occupancy fees</h2>
		<div class="mr-5 mt-5">
			<app-input
				type="cents"
				label="Monthly fees"
				name="fees"
				class="mt-3"
				[startIcon]="ICON.DOLLAR"
				[(ngModel)]="adjustment.fees"
				(ngModelChange)="changed()"
			></app-input>
			<app-radio-group
				class="mt-3"
				[items]="purchaserPaidItems"
				[label]="purchaserLabel"
				name="purchaserPaid"
				[(ngModel)]="adjustment.purchaserPaid"
				(ngModelChange)="changed()"
				type="compact"
			></app-radio-group>
			<div class="mt-3">
				<app-checkbox
					label="Apply HST ({{ hst | percent }})"
					[(ngModel)]="adjustment.applyHst"
					(ngModelChange)="changed()"
				></app-checkbox>
			</div>
			<app-input
				type="cents"
				label="Credit {{
					calculation?.creditAmount >= 0 ? 'vendor' : 'purchaser'
				}}"
				name="credit"
				class="mt-3"
				[startIcon]="ICON.DOLLAR"
				[ngModel]="calculation?.absAmount"
				[disabled]="true"
			></app-input>
			<div class="mt-3">
				<app-checkbox
					label="Include all details in document"
					[(ngModel)]="adjustment.details"
				></app-checkbox>
			</div>
		</div>
		<div class="flex justify-between mr-5 mt-5">
			<app-button btn="tertiary" class="mr-5" (click)="cancelModal()"
				>Cancel</app-button
			>
			<app-button (click)="saveModal()">Save</app-button>
		</div>
	</div>
	<div class="w-1/2">
		<app-container type="dark" title="Details">
			<div class="flex flex-1 flex-col">
				<div *ngIf="!adjustmentDate">
					Set Closing date / Adjustment date to continue
				</div>
				<div class="mb-8" *ngIf="adjustmentDate">
					<div class="flex justify-between items-start mb-3">
						<div>HST assigned to vendor based on sale price</div>
					</div>
					<div class="flex justify-between items-start mb-3">
						<div>Monthly occupancy fees</div>
						<div>{{ adjustment.fees | centsToDollars }}</div>
					</div>
					<div class="flex justify-between items-start mb-3">
						<div>
							Purchaser's shared for {{ calculation?.purchasersShareDays }} days
						</div>
						<div>{{ calculation?.purchasersShareAmount | centsToDollars }}</div>
					</div>
					<div class="flex justify-between items-start mb-8">
						<div>{{ detailLabel }}</div>
					</div>
					<div class="flex justify-end items-start">
						<div *ngIf="calculation?.creditAmount >= 0">
							<strong
								>Credit Vendor =
								{{ calculation?.creditAmount | centsToDollars }}</strong
							>
						</div>
						<div *ngIf="calculation?.creditAmount < 0">
							<strong
								>Credit Purchaser =
								{{ calculation?.creditAmount * -1 | centsToDollars }}</strong
							>
						</div>
					</div>
				</div>
			</div>
		</app-container>
	</div>
</div>
